import { H2 } from "~/ui-rtk/components/ui/typography"
import SosKeywordsForm from "~/ui-rtk/components/features/forms/SosKeywordsForm"
import useCurrentCompany from "~/ui-rtk/hooks/current-company"
import { useAuthControllerLogoutMutation } from "~/ui-rtk/api/authApi"

/**
 * Post-signup surface for SOS_FREE companies (APP-444/APP-447): the
 * Share of Search setup wizard, then a waiting state once keywords are
 * configured. Report-ready detection + email land separately
 * (APP-449/APP-450).
 *
 * Both states are a routing dead-end until the report is ready, so the page
 * carries its own logout escape (wrong account, or a company admin who wants
 * to sign in differently). Intercom never boots outside Main, so a plain
 * logout call is all the cleanup needed here.
 */
export default function SosOnboarding() {
  const currentCompany = useCurrentCompany()
  const [logout] = useAuthControllerLogoutMutation()
  const google = currentCompany?.metadata?.keywords?.google
  const isConfigured = Boolean(
    google?.categories?.length && google?.competitors?.length,
  )

  return (
    <div className="relative w-full h-full">
      <button
        type="button"
        className="btn btn-ghost btn-sm absolute top-4 right-4 z-10"
        onClick={() => void logout()}
      >
        Log out
      </button>
      {isConfigured ? (
        <div className="w-full h-full flex items-center justify-center">
          <div className="card bg-base-100 shadow-xl max-w-xl">
            <div className="card-body items-center text-center gap-4">
              <H2>We&apos;re building your report</H2>
              <p>
                Your Share of Search setup is complete. No need to check back —
                we&apos;ll email you as soon as your report is ready, usually
                within a couple of days.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex items-center justify-center overflow-y-auto">
          <div className="card bg-base-100 shadow-xl max-w-2xl w-full my-8">
            <div className="card-body gap-6">
              <div className="text-center">
                <H2>Set up your Share of Search</H2>
                <p className="mt-2">
                  Tell us your brand, categories and competitors — we&apos;ll
                  measure your share of the searches that matter and email you
                  when your report is ready.
                </p>
              </div>
              <SosKeywordsForm />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
